exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".editbtn-1 {\n  opacity: 0.5;\n  width: 20px;\n}\n\n.editbtn-1:hover {\n  opacity: 1;\n  width: 20px;\n}\n\n\n.editbtn-2 {\n  fill: #fff;\n}\n\n.editbtn-3 {\n  fill: #586671;\n}\n", ""]);
